<template>
  <div class="home">
    <v-responsive :aspect-ratio="1920 / 448">
      <v-carousel
        cycle
        show-arrows-on-hover
        hide-delimiter-background
        delimiter-icon="mdi-minus"
        height="100%"
      >
        <v-carousel-item v-for="banner in banners" :key="banner.id">
          <a :href="banner.redirect_url" target="_blank">
            <div
              :style="`height: 100%;background: url(${banner.cover_url}) center center no-repeat; background-size: cover;`"
            ></div>
          </a>
        </v-carousel-item>
      </v-carousel>
    </v-responsive>
    <div class="mt50">
      <carouselsNews />
    </div>
    <div class="mt50">
      <homeVideosVue />
    </div>
    <div class="mt50">
      <homeEventsVue />
    </div>
    <div class="mt50">
      <homeResearchVue />
    </div>
    <div style="margin-top: 16px">
      <homeForumVue />
    </div>
    <div class="mt50">
      <homePartnerVue />
    </div>
    <div class="mt50">
      <homeLinksVue />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import carouselsNews from "./components/carousels-news.vue";
import homeVideosVue from "./components/home-videos.vue";
import homeEventsVue from "./components/home-events.vue";
import homeResearchVue from "./components/home-research.vue";
import homeForumVue from "./components/home-forum.vue";
import homePartnerVue from "./components/home-partner.vue";
import homeLinksVue from "./components/home-links.vue";
import { request } from "../../utils/request";
import { api } from "../../utils/apis";

export default defineComponent({
  name: "Home",
  components: {
    carouselsNews,
    homeEventsVue,
    homeVideosVue,
    homeResearchVue,
    homeForumVue,
    homePartnerVue,
    homeLinksVue,
  },
  setup() {
    const banners = ref([]);

    request.get(`${api.banners}?page=1&page_size=6`).then((resp) => {
      resp.status === 200 && (banners.value = resp.data?.results);
    });

    return { banners };
  },
});
</script>
<style lang="scss" scoped>
.home {
  background: #f7f7f8;
  padding-bottom: 40px;
  .mt50 {
    margin-top: 40px;
  }
}
</style>
